import React from 'react';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Span, P, Margin, DownloadFile } from '@helpers';


export const Typeface = ({getFileUrl, t}) => {
    return (
      <FlexDiv direction="column">
        <PageWrapper>
          <Container paddingTop='87px' marginLeft='102px' marginRight='42px' paddingBottom='94px'>
            <FlexDiv>
              <Text width='308px' marginTop='7px' paddingBefforeText="45px" paddingAffterText='30px'>
                <h1>{t("Typeface")}</h1>
                <p>
                  {t("Correct use of typography provides the uncluttered perception of information about the company and its products, as well as forms an aesthetic concept in the eyes of the perceiver, associated with all directions of Soft-FX activities. Two types of fonts are used for text content: Montserrat and Verdana.")}
                </p>
                <DownloadFile fileName='montserrat.ttf' file={getFileUrl("montserrat")} name='montserrat'/>
                <DownloadFile fileName='verdana.ttf' file={getFileUrl("verdana")} name='verdana'/>
              </Text>
              <div>
                <Margin marginTop='67px' marginLeft='116px'>
                  <Span size='100px' weight='700' height='121.9px'>M</Span>
                  <Span size='25px' weight='700' height='30.48px'>ontserrat</Span>
                </Margin>
                <Margin marginLeft='125px'>
                  <Span size='100px' weight='700' family='Verdana' height='121.53px'>V</Span>
                  <Span size='25px' weight='700' family='Verdana' height='30.38px'>erdana</Span>
                </Margin>
              </div>
            </FlexDiv>
          </Container>
          <Container marginLeft='102px' marginRight='62px' paddingBottom='100px'>
            <FlexDiv>
              <Margin minWidth="245px">
                <P size='25px' weight='400' height='40px'>Montserrat</P>
                <P paddingTop='20px' size='16px' weight='700' height='40px'>{`Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj`}</P>
                <P size='16px' weight='400' height='40px'>{`Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj`}</P>
                <P size='16px' weight='400' height='40px'>{`0123456789 !"#$%&'()*+,-./:;<=>?`}</P>
              </Margin>
              <div>
                <Margin marginTop='62px' marginLeft='176px'>
                  <P size='15px' weight='400' height='30px'>{t("Montserrat is used as the main font on the company's website.")}</P>
                  <P paddingTop='24px' size='15px' weight='400' height='30px'>{t("Color")} #121212</P>
                </Margin>
              </div>
            </FlexDiv>
          </Container>
          <Container marginLeft='102px' marginRight='62px' marginBottom='100px'>
            <FlexDiv>
              <Margin minWidth="354px">
                <P size='25px' weight='400' family='Verdana' height='40px'>Verdana</P>
                <P paddingTop='20px' size='16px' weight='700' family='Verdana' height='40px'>{`Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj`}</P>
                <P size='16px' weight='400' family='Verdana' height='40px'>{`Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj`}</P>
                <P size='16px' weight='400' family='Verdana' height='40px'>{`0123456789 !"#$%&'()*+,-./:;<=>?`}</P>
              </Margin>
              <div>
                <Margin marginTop='67px' marginLeft='66px'>
                  <P size='15px' weight='400' family='Verdana' height='30px'>{t("Verdana is used as a font for marketing content.")}</P>
                  <P paddingTop='24px' size='15px' weight='400' family='Verdana' height='30px'>{t("Color")} #121212</P>
                </Margin>
              </div>
            </FlexDiv>
          </Container>
      </PageWrapper>
        <PageWrapper darkMode={true}>
          <Container marginTop='78px' marginLeft='102px' marginRight='62px' marginBottom='100px'>
            <FlexDiv>
              <Margin minWidth="245px">
                <P size='25px' weight='400' height='40px'>Montserrat</P>
                <P paddingTop='20px'  size='16px' weight='700' height='40px'>{`Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj`}</P>
                <P size='16px' weight='400' height='40px'>{`Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj`}</P>
                <P size='16px' weight='400' height='40px'>{`0123456789 !"#$%&'()*+,-./:;<=>?`}</P>
              </Margin>
              <div>
                <Margin marginTop='62px' marginLeft='176px'>
                  <P size='15px' weight='400' height='30px'>{t("Montserrat is used as the main font on the company's website.")}</P>
                  <P paddingTop='24px' size='15px' weight='400' height='30px'>{t("Color")} #121212</P>
                </Margin>
              </div>
            </FlexDiv>
          </Container>
          <Container marginLeft='102px' marginRight='62px' marginBottom='100px'>
            <FlexDiv>
              <Margin minWidth="354px">
                <P size='25px' weight='400' family='Verdana' height='40px'>Verdana</P>
                <P paddingTop='20px'  size='16px' weight='700' family='Verdana' height='40px'>{`Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj`}</P>
                <P size='16px' weight='400' family='Verdana' height='40px'>{`Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj`}</P>
                <P size='16px' weight='400' family='Verdana' height='40px'>{`0123456789 !"#$%&'()*+,-./:;<=>?`}</P>
              </Margin>
              <div>
                <Margin marginTop='62px' marginLeft='66px'>
                  <P size='15px' weight='400' family='Verdana' height='30px'>{t("Verdana is used as a font for marketing content.")}</P>
                  <P paddingTop='24px' size='15px' weight='400' family='Verdana' height='30px'>{t("Color")} #121212</P>
                </Margin>
              </div>
            </FlexDiv>
          </Container>
      </PageWrapper>
    </FlexDiv>
  );
};
